export const GRAPH_IDs = [
    "cascade-graph",
    "cascade-detail-graph",
    "affiliate-graph",
    "advertiser-graph",
    "offer-graph",
    "performance-graph",
    "dashboard-performance-graph",
] as const;

export type GraphId = (typeof GRAPH_IDs)[number];

export type GraphType = "entity" | "time";

export const GRAPH_TYPE: Record<GraphId, GraphType> = {
    "cascade-graph": "entity",
    "cascade-detail-graph": "entity",
    "affiliate-graph": "entity",
    "advertiser-graph": "entity",
    "offer-graph": "entity",
    "performance-graph": "time",
    "dashboard-performance-graph": "time",
};

export const HIGHLIGHT_STATE = ["active", "disabled"] as const;

export type HighlightState = (typeof HIGHLIGHT_STATE)[number];

export interface Highlight<T> {
    key: T;
    color: string;
    state: HighlightState;
    hidden?: boolean;
}

const METRIC_VALUE_TYPE = ["money", "number", "string", "percent", "unknown"] as const;
export type MetricValueType = (typeof METRIC_VALUE_TYPE)[number];

/* TODO: kinda sketchy, maybe an indicator from BE would be better */
export const PERCENTAGE_KEYS_LOOKUP: Record<GraphId, string[]> = {
    "cascade-graph": [],
    "cascade-detail-graph": [],
    "affiliate-graph": ["roi", "margin"],
    "advertiser-graph": ["roi", "margin"],
    "offer-graph": ["roi", "margin"],
    "performance-graph": ["roi", "margin"],
    "dashboard-performance-graph": ["roi", "margin"],
};

export const SECONDARY_AXIS_KEYS = ["cost", "revenue", "profit", "roi"];

export type AggregatedTableData<T> = {
    [K in keyof T]: T[K] extends App.Data.MoneyData
        ? { amount: number; currency_id: number }
        : T[K] extends number
          ? number
          : T[K] extends string
            ? string
            : never;
};

type Prev = [never, 0, 1, 2, 3, 4, 5];

type NestedPathsInternal<T, D extends number = 5> = [D] extends [never]
    ? never
    : {
          [K in keyof T]: Exclude<T[K], undefined> extends object
              ? K | `${K & string}.${NestedPathsInternal<Exclude<T[K], undefined>, Prev[D]> & string}`
              : K;
      }[keyof T];

export type NestedPaths<T, Depth extends number = 5> = NestedPathsInternal<T, Depth>;
